import { Grid, Typography } from '@mui/material';
import NoResultsImage from '@assets/FiltersNoResults.svg';

interface Props {
	height: string | number;
	stylesTitle?: any;
	stylesText?: any;
}

const FiltersNoResults: React.FC<Props> = ({ height }) => (
	<Grid
		container
		alignItems="center"
		direction="column"
		justifyContent="center"
		style={{ height }}
	>
		<Grid item>
			<img alt="No hay resultados" src={NoResultsImage} />
		</Grid>
		<Grid item style={{ marginTop: 32 }}>
			<Typography color="#1063AC" fontFamily="Montserrat" fontSize={22} fontWeight={600}>
				No se encontraron resultados
			</Typography>
		</Grid>
		<Grid item style={{ marginTop: 8 }}>
			<Typography color="#000000DE" fontFamily="Montserrat" fontSize={14}>
				Parece que no podemos encontrar ningún resultado basado en tu búsqueda
			</Typography>
		</Grid>
	</Grid>
);

export default FiltersNoResults;
